
/**
 *  find js function by name in context (window for example)
 *  @alias Ptx.sys.getFunction
 */
export function getFunction(functionName, context) {
	var args = [].slice.call(arguments).splice(2);
	var namespaces = functionName.split(".");
	var func = namespaces.pop();
	for (var i = 0; i < namespaces.length; i++) {
		context = context[namespaces[i]];
	}
	return context[func];
}

/**
 * Execute function by name
 * @alias Ptx.sys.execFunction
 * @param functionName
 * @param context
 * @param args
 * @returns function
 */
export function execFunction(functionName, context , args) {
	return getFunction(functionName, context).apply(this, args);
}

/**
 * allow repeated insert of google maps script by unloading them
 * @alias Ptx.sys.unloadGoogleMapsApi
 */
export function unloadGoogleMapsApi() {
	if (window.google && google.maps) {
		delete google.maps;
		google.maps = null;
	}
}